var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 10 } },
    [
      _c(
        "a-col",
        { attrs: { md: 8, sm: 24 } },
        [
          _c("a-card", { attrs: { bordered: false } }, [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#fff",
                  "padding-left": "16px",
                  height: "100%",
                  "margin-top": "5px",
                },
              },
              [
                _c("a-input-search", {
                  staticStyle: { width: "100%", "margin-top": "10px" },
                  attrs: { placeholder: "请输入部门名称" },
                  on: { search: _vm.onSearch },
                }),
                _vm.userIdentity === "2" && _vm.departTree.length > 0
                  ? [
                      _c("a-tree", {
                        attrs: {
                          showLine: "",
                          selectedKeys: _vm.selectedKeys,
                          checkStrictly: true,
                          dropdownStyle: {
                            maxHeight: "200px",
                            overflow: "auto",
                          },
                          treeData: _vm.departTree,
                          autoExpandParent: _vm.autoExpandParent,
                          expandedKeys: _vm.iExpandedKeys,
                        },
                        on: { select: _vm.onSelect, expand: _vm.onExpand },
                      }),
                    ]
                  : _vm.userIdentity === "2" && _vm.departTree.length == 0
                  ? _c("div", { staticStyle: { "margin-top": "24px" } }, [
                      _c("h3", [
                        _c("span", [_vm._v("您的部门下暂无有效部门信息")]),
                      ]),
                    ])
                  : _c("div", { staticStyle: { "margin-top": "24px" } }, [
                      _c("h3", [_vm._v("普通员工暂此权限")]),
                    ]),
              ],
              2
            ),
          ]),
        ],
        1
      ),
      _c(
        "a-col",
        { attrs: { md: 16, sm: 24 } },
        [
          _c(
            "a-card",
            { attrs: { bordered: false } },
            [
              _c(
                "a-tabs",
                {
                  attrs: { defaultActiveKey: "2" },
                  on: { change: _vm.callback },
                },
                [
                  _c(
                    "a-tab-pane",
                    { key: "1", attrs: { tab: "基本信息", forceRender: "" } },
                    [_c("Dept-Base-Info", { ref: "DeptBaseInfo" })],
                    1
                  ),
                  _c(
                    "a-tab-pane",
                    { key: "2", attrs: { tab: "用户信息" } },
                    [
                      _c("Dept-User-Info", {
                        ref: "DeptUserInfo",
                        on: {
                          clearSelectedDepartKeys: _vm.clearSelectedDepartKeys,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-tab-pane",
                    { key: "3", attrs: { tab: "部门角色", forceRender: "" } },
                    [
                      _c("dept-role-info", {
                        ref: "DeptRoleInfo",
                        on: {
                          clearSelectedDepartKeys: _vm.clearSelectedDepartKeys,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }